// extracted by mini-css-extract-plugin
export var attribution = "_2m-4";
export var authorName = "_2m-5";
export var option = "_2m-f";
export var optionCard = "_2m-u";
export var optionContent = "_2m-v";
export var optionGrid = "_2m-11";
export var optionIcon = "_2m-x";
export var optionIconBox = "_2m-w";
export var optionLabel = "_2m-y";
export var optionList = "_2m-e";
export var optionPill = "_2m-12";
export var optionPillBadge = "_2m-15";
export var optionPillIcon = "_2m-13";
export var optionPillLabel = "_2m-14";
export var optionRadio = "_2m-z";
export var optionRadioInner = "_2m-10";
export var optionReveal = "_2m-h";
export var optionRevealDelay0 = "_2m-i";
export var optionRevealDelay1 = "_2m-j";
export var optionRevealDelay10 = "_2m-s";
export var optionRevealDelay11 = "_2m-t";
export var optionRevealDelay2 = "_2m-k";
export var optionRevealDelay3 = "_2m-l";
export var optionRevealDelay4 = "_2m-m";
export var optionRevealDelay5 = "_2m-n";
export var optionRevealDelay6 = "_2m-o";
export var optionRevealDelay7 = "_2m-p";
export var optionRevealDelay8 = "_2m-q";
export var optionRevealDelay9 = "_2m-r";
export var optionSelected = "_2m-g";
export var questionsBlock = "_2m-17";
export var quote = "_2m-3";
export var spacer = "_2m-b";
export var stepCenteredContent = "_2m-9";
export var stepInner = "_2m-6";
export var stepInnerFullWidth = "_2m-7";
export var stepInnerLockScroll = "_2m-8";
export var stepTransitionFrame = "_2m-a";
export var subtitle = "_2m-d";
export var testimonial = "_2m-2";
export var title = "_2m-c";
export var trustedBy = "_2m-0";
export var trustedByLabel = "_2m-1";
export var welcomeBlock = "_2m-16";